export default __webpack_public_path__ + "static/media/rahasazi-daryache.e3b3e6bc.png";